import { defineNuxtPlugin, useHeadSafe } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("app:mounted", () => {
    useHeadSafe({
      bodyAttrs: {
        "data-qa-ready": "true"
      }
    });
  });
});
